import React, { FC } from 'react';
import { useMediaQuery } from 'react-responsive';

import OwerServices from '../OwerServices';

import { Margin } from '~/components/Margin';

import { Breakpoints } from '~/styles';
import { Container, Main, Swipper } from '../styles';
import EmptyMessage from '~/components/EmptyMessage';

const HomeManager: FC = () => {
  const isMobile = useMediaQuery({ maxWidth: Breakpoints.tablet.max });

  return (
    <Main>
      <Margin height={isMobile ? 0 : 56} />
      <Container>
        <Swipper />
      </Container>

      <Margin height={150} />
      <EmptyMessage textMessage="Estamos preparando novas funcionalidades para você!" />
      <Margin height={60} />

      <OwerServices />
    </Main>
  );
};

export default HomeManager;
